import {IEvent, TikModelEventHighlightTypes} from "@webng-types/write-model";

type Highlight = TikModelEventHighlightTypes | undefined

function isHighlighted(highlight: Highlight): boolean {
  return highlight === "inplace" || highlight === "sticky"
}

function isSticky(highlight: Highlight): boolean {
  return highlight === "sticky" || highlight === "stickyNoHighlight"
}

export function isHighlightedEvent(event: IEvent): boolean {
  return isHighlighted(event.highlight)
}

export function isStickyEvent(event: IEvent): boolean {
  return isSticky(event.highlight)
}

export function highlightValue(sticky: boolean, highlighted: boolean): TikModelEventHighlightTypes {
  if (sticky && highlighted) {
    return "sticky";
  } else if (sticky) {
    return "stickyNoHighlight";
  } else if (highlighted) {
    return "inplace";
  } else {
    return "";
  }
}

export function unpinnedHighlight(highlight: Highlight): Highlight {
  return isSticky(highlight) ? highlightValue(false, isHighlighted(highlight)) : highlight
}

export function unhighlightedHighlight(highlight: Highlight): Highlight {
  return isHighlighted(highlight) ? highlightValue(isSticky(highlight), false) : highlight
}
